import { EuiPanel } from "@inscopix/ideas-eui";
import { ProjectTablesDndProvider } from "components/ProjectTablesTable/ProjectTablesDndProvider";
import { ProjectTablesTableLayout } from "components/ProjectTablesTable/ProjectTablesTableLayout";
import { ProjectTablesTableProvider } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";

export const PanelProjectTables = () => {
  return (
    <EuiPanel paddingSize="l" hasShadow={false} hasBorder={true}>
      <ProjectTablesTableProvider>
        <ProjectTablesDndProvider>
          <ProjectTablesTableLayout />
        </ProjectTablesDndProvider>
      </ProjectTablesTableProvider>
    </EuiPanel>
  );
};
